import clsx from "clsx";

import { CheckIcon } from "./i/check";

/**
 * 部屋タイプ予約ブラウズ用チェックボックス atom。
 *
 * Figma（SP: 5171-10410 / PC: 5141-8041 内 Check コンポーネント）準拠:
 * - 20×20px, rounded-[2px]
 * - チェック済み: bg-dx-text-default（暗色塗り）+ 白チェックマーク
 * - 未チェック: bg-dx-surface-subtle + border-[1.5px] border-dx-text-default
 * - タップターゲット: min-h-[48px], min-w-[40px] の中央配置
 *
 * フォーカスリング: WCAG 2.4.7 準拠。
 * `group` クラスを持つ親 label に `sr-only` な input が内包される前提で
 * `group-has-[:focus-visible]:` を使い 20×20 の box にリングを描画する。
 * ring 色: dx-border-focus（color/boundary/focus）。
 */
export function Checkbox({ checked }: { checked: boolean }) {
  return (
    <div className="flex min-h-[48px] min-w-[40px] shrink-0 items-center justify-center py-[8px]">
      <div
        className={clsx(
          "flex size-[20px] shrink-0 items-center justify-center rounded-[2px] transition-colors duration-150",
          "group-has-[:focus-visible]:ring-dx-border-focus group-has-[:focus-visible]:ring-2 group-has-[:focus-visible]:ring-offset-1",
          checked
            ? "bg-dx-text-default group-hover:bg-dx-bg-inverse"
            : "border-dx-text-default bg-dx-surface-subtle group-hover:bg-dx-bg-selected border-[1.5px]",
        )}
      >
        {checked && <CheckIcon className="text-dx-text-inverse size-[16px]" />}
      </div>
    </div>
  );
}
